<script lang="ts" setup>
import { TabsContent, type TabsContentProps } from "radix-vue";
import { type HTMLAttributes, computed } from "vue";
import { cn } from "../../utils";

const props = defineProps<
  TabsContentProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <TabsContent
    :class="cn('w-full outline-hidden', props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </TabsContent>
</template>
